function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMeasurementHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-hidden": "true",
    focusable: "false",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m 14.663499,3.6676415 v 8.6647165 c 0,0.183293 -0.149966,0.333259 -0.333258,0.333259 -0.183292,0 -0.333259,-0.149966 -0.333259,-0.333259 V 8.4065755 l -1.096419,1.096419 c -0.06665,0.06665 -0.149967,0.09665 -0.236614,0.09665 -0.08665,0 -0.169962,-0.03333 -0.236613,-0.09665 -0.129971,-0.12997 -0.129971,-0.339923 0,-0.469894 l 0.699842,-0.699842 H 2.79617 l 0.763162,0.686512 c 0.136636,0.123305 0.146634,0.333258 0.02333,0.469894 -0.06665,0.07332 -0.156631,0.109975 -0.246611,0.109975 -0.07998,0 -0.159964,-0.02666 -0.223283,-0.08665 l -1.10975,-1.003107 v 3.8191405 c 0,0.183292 -0.149967,0.333258 -0.333259,0.333258 -0.183292,0 -0.333258,-0.149966 -0.333258,-0.333258 V 3.6676415 c -2e-6,-0.183292 0.149964,-0.333258 0.333256,-0.333258 0.183292,0 0.333259,0.149966 0.333259,0.333258 v 3.925783 l 1.096419,-1.09642 c 0.129971,-0.12997 0.339924,-0.12997 0.469895,0 0.12997,0.129971 0.12997,0.339924 0,0.469895 l -0.699843,0.699842 h 10.334341 l -0.763162,-0.686512 c -0.136636,-0.123306 -0.146634,-0.333258 -0.02333,-0.469894 0.123306,-0.136636 0.333258,-0.146634 0.469894,-0.02333 l 1.10975,1.003107 v -3.81914 c 0,-0.183292 0.149967,-0.333258 0.333259,-0.333258 0.183292,0 0.333258,0.149966 0.333258,0.333258 z",
    id: "path1",
    style: {
      strokeWidth: 0.666517
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeasurementHorizontal);
export default __webpack_public_path__ + "static/media/measurementHorizontal.041d1c6612edd647b9731ef75f1fa38e.svg";
export { ForwardRef as ReactComponent };